
import { createSlice } from '@reduxjs/toolkit';

export const genreOrCategory = createSlice({
  name: 'genreOrCategory',
  initialState: {
    genreIdOrCategoryName: '',
    page: 1,
    searchQuery: '',
  },
  reducers: {
    selectGenreOrCategory: (state, action) => {
      // console.log(action.payload);
      // eslint-disable-next-line no-param-reassign
      state.genreIdOrCategoryName = action.payload;
    },
  },

});

export const { selectGenreOrCategory } = genreOrCategory.actions;

export default genreOrCategory.reducer;
